import { render, staticRenderFns } from "./ParticipantsImportComponent.vue?vue&type=template&id=22312df3&"
import script from "./ParticipantsImportComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantsImportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsImportComponent.vue?vue&type=style&index=0&id=22312df3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports